import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DialogDataService {
  private data: any;

  setData(data: any) {
    this.data = data;
  }

  getData() {
    return this.data;
  }

  clearData(): void {
    this.data = undefined; // Set data to undefined
  }
}